import React from "react";
import PropTypes from "prop-types";

import Button from "../../../../atoms/Button";
import cs from "classnames";
import classes from "./FirstStep.module.scss";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { APPLICATION_ROUTES } from "../../../../../constants";
import GoogleAuth from "../../../../organisms/GoogleAuth";
import { observer } from "mobx-react-lite";
import { useQuery } from "../../../../../hooks";

const FirstStep = observer(({ onSubmit }) => {
  const { t } = useTranslation();

  const query = useQuery();
  const redirectPageURL = query.get("redirect");

  const TEXT = (
    <Trans
      components={{
        a: (
          <Link
            className="c-orange"
            to={
              !redirectPageURL
                ? APPLICATION_ROUTES.SIGN_IN
                : APPLICATION_ROUTES.SIGN_IN + "?redirect=" + redirectPageURL
            }
          />
        ),
      }}
      i18nKey="pages.authorization.sign_up.text.1"
      t={t}
    />
  );

  const TITLE = t("pages.authorization.sign_up.title");

  // const TEXT_2 = <Trans components={{ a: <br />, b: <b /> }} i18nKey="pages.authorization.sign_up.text.2" t={t} />;

  return (
    <form className="d-flex fd-column ai-center" onSubmit={onSubmit}>
      <div className="mb-10">
        <h2 className="heading-m-a ta-center c-blue-dark">{TITLE}</h2>
      </div>

      <div className={cs(classes.signUpContainer, "mt-10")}>
        <div className={cs(classes.optionsContainer)}>
          <Button type="submit" borderRadius="8" size="m">
            {t("pages.authorization.sign_up.text.5")}
          </Button>
          <div className={cs(classes.orSeparator, "mt-05", "mb-05")}>
            <label>{t("pages.authorization.sign_up.text.6")}</label>
          </div>
          <div>
            <GoogleAuth />
          </div>
        </div>
      </div>
      <div className="mt-05 mb-10 w-100p fw-500 ta-center c-blue-dark">{TEXT}</div>
      <div className={cs("mt-10 ta-center", classes.lineHeight30)}>
        <Trans
          i18nKey="pages.authorization.sign_up.text.7"
          components={{
            1: <br className={cs(classes.mobileBreak)} />,
            2: <b />,
            3: <br />,
          }}
        />
      </div>
    </form>
  );
});

const inputPropTypes = PropTypes.shape({
  error: PropTypes.string.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.string.isRequired,
  touched: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}).isRequired;

FirstStep.propTypes = {
  email: inputPropTypes,
  isNotValid: PropTypes.bool.isRequired,
  lastName: inputPropTypes,
  firstName: inputPropTypes,
  referralCode: inputPropTypes,
  onSubmit: PropTypes.func.isRequired,
};

export default FirstStep;
